import { Injectable, inject } from '@angular/core';
import { PublicApiService } from '../services/public-api.service';

@Injectable({
  providedIn: 'root',
})
export class PublicAuthorisedPaListResolver {
    public readonly publicApiService = inject(PublicApiService);

    resolve() {
      return this.publicApiService.getPaSearchList$();
    }
}
